<template>
  <v-container>
    <h1 class="text-center">درخواست ثبت نام مدرسه ای</h1>
    <p v-if="!completed" class="text-center red--text">
      به منظور دریافت تقدیر نامه و کد تخفیف با اسم و لوگو مدرسه
    </p>
    <div v-if="completed" class="my-2">
      <p class="text-center green--text mb-2">
        همکار گرامی؛ از درخواست شما سپاسگذاریم.اطلاعات شما با موفقیت ثبت گردید.
        پس از تایید اطلاعات، نام کاربری و کلمه عبور برای شما ارسال خواهد شد تا
        سفارش خود را تکمیل کنید.
      </p>
      <v-img
        v-if="completed"
        class="my-10 mx-auto"
        width="500"
        src="~@/assets/images/mainpage.gif"
      />
    </div>
    <v-alert v-if="!completed" dense type="error" class="text-center">
      توجه : این بخش صرفا ویژه سفارش مدیران مدارس می باشد. لطفا دانش آموزان از
      بخش "ثبت نام" اقدام نمایند.
    </v-alert>
    <v-row justify="center">
      <v-col v-if="!completed" cols="12" md="5" class="text-justify">
        <p>
          مدارس به منظور دریافت 30 درصد تخفیف برای دانش‌آموزان مدرسه خود
          می‌توانند با پر کردن فرم درخواست زیر و تایید و دریافت نام کاربری و رمز
          عبور خود اقدام به خرید نمایند. بعد از
          <v-chip dense primary outlined class="px-1"> تایید درخواست </v-chip>
          توسط سامانه و ارسال نام کاربری و رمز عبور؛ مدرسه می تواند به تعداد
          کتاب درخواستی، فرم سفارش را پر کرده و کد رایگان دریافتی را در اختیار
          اولیای دانش‌آموزان قرار دهند.
        </p>
        <p class="font-weight-bold">
          مدارس می توانند با استفاده از این خدمت در بخش کنترل پنل مدرسه؛ گزارش
          عملکرد دانش آموزان خود را مشاهده نمایند.
        </p>
        <v-alert
          border="left"
          colored-border
          type="info"
          elevation="2"
          class="mt-5"
        >
          پیشنهاد می شود فیلم راهنمای زیر را مشاهده نمایید.
        </v-alert>
        <vue-plyr>
          <video src="https://dl.pirls.ir/app/how.mp4"></video>
        </vue-plyr>
      </v-col>
      <v-col v-if="!completed" cols="12" md="7">
        <v-card outlined class="pa-5 px-7 pb-8">
          <div class="d-flex align-center mb-3">
            <h3 class="flex-fill">فرم درخواست</h3>
            <v-btn
              depressed
              outlined
              small
              color="primary"
              href="https://t.me/PirlsSupport"
              target="_blank"
            >
              <v-icon class="ml-2 mr-0">mdi-telegram</v-icon>
              پشتیبانی تلگرام
            </v-btn>
          </div>
          <form-alert v-if="error" :message="error.response.data.message" />
          <v-form
            v-model="valid"
            @submit.prevent="checkUser"
            class="text-center"
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="title"
                  :rules="titleRules"
                  autocomplete="off"
                  label="نام مدرسه"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="moderator"
                  :rules="moderatorRules"
                  autocomplete="off"
                  label="مدیر مدرسه"
                  hint="نام و نام خانوادگی مدیر مدرسه را وارد نمایید"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  outlined
                  dense
                  :items="typeItems"
                  v-model="type"
                  :rules="typeRules"
                  label="نوع مدرسه"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="coordinator"
                  :rules="coordinatorRules"
                  autocomplete="off"
                  label="نماینده مدرسه"
                  hint="نام و نام خانوادگی نماینده مدرسه را وارد نمایید"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="mobilenumber"
                  :rules="mobilenumberRules"
                  type="number"
                  autocomplete="off"
                  label="شماره موبایل"
                  hint="شماره موبایل به عنوان نام کاربری استفاده خواهد شد"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="phoneNumber"
                  type="number"
                  :rules="phoneNumberRules"
                  autocomplete="off"
                  label="تلفن ثابت مدرسه"
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  outlined
                  dense
                  :items="stateItems"
                  v-model="state"
                  :rules="stateRules"
                  label="استان"
                  required
                />
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  outlined
                  dense
                  v-model="address"
                  :rules="addressRules"
                  autocomplete="off"
                  label="آدرس مدرسه"
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="agent"
                  type="number"
                  label="معرف"
                  hint="در صورت داشتن معرف کد معرف خود را در این بخش وارد نمایید"
                  autocomplete="off"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="8">
                <v-file-input
                  v-model="image"
                  :rules="imageRules"
                  accept="image/png, image/jpeg"
                  label="لوگو مدرسه"
                  outlined
                  dense
                  required
                />
              </v-col>
            </v-row>
            <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              depressed
              block
              color="primary"
              type="submit"
              class="flex-grow-1"
            >
              ارسال درخواست
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center mt-5">
      <v-btn router to="/" text> بازگشت </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "school-register-component",
  data: () => {
    return {
      loading: false,
      valid: false,
      errored: false,
      completed: false,
      error: "",
      title: "",
      titleRules: [(v) => !!v || "لطفا نام مدرسه خود را وارد نمایید"],
      moderator: "",
      moderatorRules: [(v) => !!v || "لطفا نام مدیر مدرسه را وارد نمایید"],
      type: "",
      typeRules: [(v) => !!v || "لطفا نوع مدرسه را انتخاب نمایید"],
      coordinator: "",
      coordinatorRules: [(v) => !!v || "لطفا نام رابط مدرسه را وارد نمایید"],
      mobilenumber: "",
      mobilenumberRules: [
        (v) => !!v || "لطفا تلفن همراه رابط مدرسه را وارد نمایید",
        (v) => (v && v.length == 11) || "تلفن همراه را به درستی وارد نمایید"
      ],
      phoneNumber: "",
      phoneNumberRules: [
        (v) => !!v || "لطفا تلفن ثابت مدرسه را وارد نمایید",
        (v) =>
          (v && v.length == 11) ||
          "تلفن ثابت را به همراه کد و به درستی وارد نمایید"
      ],
      state: "",
      stateRules: [(v) => !!v || "لطفا استان خود را انتخاب نمایید"],
      address: "",
      addressRules: [(v) => !!v || "لطفا آدرس پستی مدرسه خود را وارد نمایید"],
      agent: "",
      image: null,
      imageRules: [
        (v) =>
          !!v || "لطفا یک عکس مناسب از لوگو مدرسه خود را انتخاب و آپلود نمایید"
      ],
      typeItems: ["دولتی", "غیردولتی"],
      stateItems: [
        "آذربایجان شرقی",
        "آذربایجان غربی",
        "اردبیل",
        "اصفهان",
        "البرز",
        "ایلام",
        "بوشهر",
        "تهران",
        "چهارمحال و بختیاری",
        "خراسان جنوبی",
        "خراسان رضوی",
        "خراسان شمالی",
        "خوزستان",
        "زنجان",
        "سمنان",
        "سیستان و بلوچستان",
        "فارس",
        "قزوین",
        "قم",
        "کردستان",
        "کرمان",
        "کرمانشاه",
        "کهگیلویه و بویراحمد",
        "گلستان",
        "گیلان",
        "لرستان",
        "مازندران",
        "مرکزی",
        "هرمزگان",
        "همدان",
        "یزد"
      ]
    };
  },

  methods: {
    checkUser() {
      this.loading = true;
      this.$api
        .post("user/exists", {
          mobilenumber: this.mobilenumber
        })
        .then((res) => {
          if (res.status == 406) {
            this.errored = true;
            this.error = res.data.message;
            this.loading = false;
          } else {
            this.handleSchoolPreRegister();
          }
        })
        .catch((err) => {
          this.errored = true;
          this.error = err;
          this.loading = false;
        });
    },
    handleSchoolPreRegister() {
      const tempPass = Math.random().toString(36).slice(2);
      this.$api
        .post("school/register", {
          title: this.title,
          phoneNumber: this.phoneNumber,
          mobilenumber: this.mobilenumber,
          moderator: this.moderator,
          coordinator: this.coordinator,
          type: this.type,
          state: this.state,
          address: this.address,
          agent: this.agent,
          tempPass: tempPass
        })
        .then((res) => {
          const schoolId = res.data.school._id;
          let formData = new FormData();
          formData.append("image", this.image);
          this.$api
            .post("/school/image/" + schoolId, formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(() => {
              this.completed = true;
              this.$store.commit("clearMessageState");
              this.$store.commit("setMessageState");
              this.$store.commit("setMessageType", "success");
              this.$store.commit(
                "setMessage",
                "اطلاعات شما با موفقیت ثبت گردید. در صورت تایید اطلاعات؛ نام کاربری و کلمه عبور برای شما ارسال خواهد شد."
              );
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              this.errored = true;
              this.errorMessage = err;
            });
        })
        .catch((err) => {
          this.loading = false;
          this.errored = true;
          this.errorMessage = err;
        });
    }
  }
};
</script>
